import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {order,iStatusOperation, selectByGlasses, glass} from '../../services/api/api'
// Models


export interface client {
    client?: { type: 'client', data: { id: number; name: string; } };
    phone?: string;
    address?: string;
}
export type tGlassworksValue = selectByGlasses&{value:number,name:string}
export type tGlassValue = glass&{value:number,name:string}
export interface iGlassWorks {[key:number |string]:tGlassworksValue[]}
interface iGlasses {[key:number |string]:tGlassValue[]}
// Orders state
export interface orderState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    loadingClients:boolean,
    hasMore: boolean,
    order: order,
    client?: client,
    glasses:iGlasses,
    pricing?:any[],
    glassWorks:iGlassWorks,
    fetched_glassworks : iGlassWorks,
    operationsStatus:iStatusOperation[],
    client_list:any[],
    fetched_ids  :{[key:number]:number}
    ids_pending_fetch:{[key:number]:number}
}

const initialOrdersState: orderState = {
    isLoaded: false,
    isLoading: false,
    loadingClients:false,
    isFetching: false,
    hasMore: true,
    order: {
        id: 0,
        order_no: "",
        date: "",
        summary: "",
        client_name: "",
        client_id: 0,
        job_order_printed: false,
        isLoadingPrintOrder: false,
        orderdetail:[],
        delivery_date:'',
        orderstatus:undefined
        
    },
    glasses:{},
    pricing:[],
    glassWorks:{},
    fetched_glassworks:{},
    operationsStatus:[],
    client_list:[],
    fetched_ids:{},
    ids_pending_fetch:{}
}

// Orders slice
export const orderSlice = createSlice({
    name: 'order',
    initialState: initialOrdersState,
    reducers: {
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setIsLoadingClients: (state, { payload }: PayloadAction<boolean>) => {
            state.loadingClients = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsLoadingPrintOrder: (state, { payload }: PayloadAction<boolean>) => {
            state.order.isLoadingPrintOrder = payload
        },
        changeJobOrderState: (state, { payload }: PayloadAction<boolean>) => {
            state.order.job_order_printed = payload
        },
        setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
            state.isFetching = payload
        },
        setHasMore: (state, { payload }: PayloadAction<boolean>) => {
            state.hasMore = payload
        },
        setOrder: (state, { payload }: PayloadAction<order>) => {
            state.order = payload
        },
        setClient: (state, { payload }: PayloadAction<client>) => {
            state.client = payload
        },
        setGlasses:(state,{payload}:PayloadAction<{data:any,index:number|'general'}>)=>{
      
            state.glasses[payload.index]=payload.data
        },
        initGlassworks:(state)=>{
            state.glassWorks={}
          
        },
        setGlassWords:(state,{payload}:PayloadAction<{data:tGlassworksValue[],index:number|'general'}>)=>{
            state.glassWorks[payload.index]=payload.data
           
            if (typeof(payload.index) == 'number') {
              for (let [key ,value ] of Object.entries(state.fetched_ids)) {
                if (value === payload.data[0]?.gid) {
                    state.fetched_glassworks[key]=payload.data
                }
              }
                for (let [key,value] of Object.entries(state.ids_pending_fetch)) {
                     
                    if (value === payload.data[0]?.gid){
                        state.glassWorks[key]= payload.data
                       
                        delete state.ids_pending_fetch[parseInt(key)]
                    }
                }
            }
           
 
        },
        copyGlassWorks:(state,{payload}:PayloadAction<{arr_index:string[]}>)=>{
           
            let new_glassworks = payload.arr_index.map(ele=>state.glassWorks[parseInt(ele)] )
            let values=Object.values(state.glassWorks).concat(new_glassworks)
            let new_galssWorks:iGlassWorks={}
            values.map((val,index)=> {
                new_galssWorks[index]=val
            })
            state.glassWorks=new_galssWorks


        },
        deleteGlassWorks:(state,{payload}:PayloadAction<{arr_index:string[]}>)=>{
            payload.arr_index.map(ele =>{

                delete state.glassWorks[parseInt(ele)] 
            })
            let values= Object.values(state.glassWorks)
            let new_galssWorks:iGlassWorks={}
            values.map((val,index)=> {
                new_galssWorks[index]=val
            })
            state.glassWorks=new_galssWorks
        },
        deleteGlassWorks_old:(state,{payload}:PayloadAction<{index:number|'general'}>)=>{
            delete state.glassWorks[payload.index] 
            let values= Object.values(state.glassWorks)
            let new_galssWorks:iGlassWorks={}
            values.map((val,index)=> {
                new_galssWorks[index]=val
            })
            state.glassWorks=new_galssWorks
        },
        
        
        setPricing:(state,{payload})=>{
           
            state.pricing=payload
        },
        setClientList:(state,{payload})=>{
           
            state.client_list=payload && payload.list? payload.list:[]
        },

        updateInvoiceIssued:(state,{payload}:PayloadAction<{  invoice_issued: string | boolean}>)=>{
            state.order.invoice_issued=payload.invoice_issued as boolean
         },
         updateDeliveryOrderIssued:(state,{payload}:PayloadAction<{  delivery_order_issued: string |boolean}>)=>{
          state.order.delivery_order_issued=payload.delivery_order_issued as boolean
         },
         updateJobOrderPrinted:(state,{payload}:PayloadAction<{job_order_printed:boolean}>)=>{
          state.order.job_order_printed=payload.job_order_printed
         },
         setStatusOperations :(state,{payload}:PayloadAction<iStatusOperation[]>)=>{
            state.operationsStatus=[...payload.slice(0,13)
               ]
        }
        ,
        initFetchedIds:(state,{payload}:PayloadAction<{[key:number]:number}>)=>{
            state.fetched_ids=payload
        },
         initIdsPendingFetch:(state,{payload}:PayloadAction<{[key:number]:number}>)=>{
            state.fetched_ids=payload
        },
        setFetchedIds:(state,{payload}:PayloadAction<{index:number,glass_id:number}>)=>{
            state.fetched_ids[payload.index]=payload.glass_id
        },
        setIdsPendingFetch:(state,{payload}:PayloadAction<{index:number,glass_id:number}>)=>{

            state.ids_pending_fetch[payload.index]=payload.glass_id
        },
        removeFetchedIds:(state,{payload}:PayloadAction<{arr_index:number[]}>)=>{
            payload.arr_index.map(ele =>{
                delete state.fetched_ids[ele]
            })
         
        },
        removeIdsPendingFetch:(state,{payload}:PayloadAction<{arr_index:number[]}>)=>{
            payload.arr_index.map(ele =>{   
            delete state.ids_pending_fetch[ele]

        })
        },
        resetOrder:(state)=>{
            state.order={}
        }
    }
})